module.exports = __webpack_public_path__ + "static/media/watch2.31303d5f.jpg";